<template>
  <div class="record-wrapper" v-if="isactive">
    <div class="search-box">
      <w-row :gutter="20" class="search-line">
        <w-col :span="16">
          <label class="label">时间段</label>
          <vue-datepicker-local format="YYYY-MM-DD" clearable v-model="fromTime"></vue-datepicker-local>
          ~
          <vue-datepicker-local format="YYYY-MM-DD" clearable v-model="toTime"></vue-datepicker-local>
        </w-col>
      </w-row>
      <w-row class="search-line">
        <div class="search-item search-item-1">
          <label class="label">操作</label>
          <w-select v-model="optionValue" id="searchOperate">
            <w-option
              v-for="(i,index) in operationTypes"
              :value="i.value"
              :label="i.label"
              :key="index"></w-option>
          </w-select>
        </div>
        <div class="search-item">
          <label for="searchDetail">操作详情</label>
          <input class="input__inner" type="text" v-model="detail" id="searchDetail"/>
        </div>
        <div class="search-item">
          <label for="searchAccount">操作者账号</label>
          <input class="input__inner" type="text" v-model="account" id="searchAccount"/>
        </div>
        <div class="search-item margin-left-10">
          <w-button type="minor" @click="search">查询</w-button>
        </div>
      </w-row>
    </div>
    <div class="table-box" id="table-box" :class="total > pageSize?'table-box-page':''">
      <simple-table :height="tableHeight - (total > pageSize ? 50 : 0)" :showNoData="dataList.length === 0"
                    no-data-text="暂无企业管理记录">
        <template slot="header">
          <thead class="has-gutter">
          <tr class>
            <th width="110">
              <em
                class="sort-btn-fixed position-relative"
                @click="timeSort"
                data-type="operateTime"
              >
                时间
                <i class="sort" :class="timeActive? 'sort-down': 'sort-up'"></i>
              </em>
            </th>
            <th width="70">操作</th>
            <th width="220">操作详情</th>
            <th width="150">操作者账号</th>
            <th width="70">登录地区</th>
            <th width="150">登录IP</th>
          </tr>
          </thead>
        </template>
        <template slot="body" v-if="dataList.length>0">
          <tbody id="projectContent">
          <tr>
            <td width="110" style="height: 40px;">
              <a class="sort-btn-fixed" data-type="operateTime">
                时间
                <i class="sort"></i>
              </a>
            </td>
            <td width="70" style="height: 40px;">操作</td>
            <td width="220" style="height: 40px;">操作详情</td>
            <td width="150" style="height: 40px;">操作者账号</td>
            <td width="70" style="height: 40px;">登录地区</td>
            <td width="150" style="height: 40px;">登录IP</td>
          </tr>
          <tr v-for="(data, index) in dataList" :key="index">
            <td width="110">{{data.gmtCreate | formatDate}}</td>
            <td width="70">{{data.operateType | formatOptType}}</td>
            <!--<td width="70">{{data.operateType === 'UNBIND' ? '解除组织关系' : data.operateType === 'ADD' ? '新建组织关系' : ''}}</td>-->
            <td width="220">
              <el-tooltip v-if="data.detail">
                <div slot="content">
                  <ul style="max-height: 300px;overflow-y: auto;">
                    <template v-for="(item, index) in data.detail.split(';')">
                      <li class="padding-0-10"
                          v-if="item"
                          :class="{'margin-top-10': index}"
                          :key="item">
                        {{item}}
                      </li>
                    </template>
                  </ul>
                </div>
                <div class="ellipsis">{{data.detail}}</div>
              </el-tooltip>
            </td>
            <td width="150">{{data.account}}</td>
            <td width="70">{{data.area}}</td>
            <td width="150">{{data.ip}}</td>
          </tr>
          </tbody>
        </template>
      </simple-table>
    </div>
    <div class="page-box" v-if="total > pageSize">
      <w-pagination
        @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange"
        :current-page.sync="currentPage"
        background
        layout="total, prev, pager, next, jumper,sizes"
        :page-size="pageSize"
        :page-sizes="[50, 100]"
        :total="total"
      ></w-pagination>
    </div>
  </div>
</template>

<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import {getCookie} from '@/assets/utils/CommonUtil'
import {SimpleTable} from '@/components/common'
import ManageService from '@/assets/service/manage'
import {formatDate} from '@/assets/utils/Date'

let projectId = getCookie('enterpriseWorkspaceIdValue')
export default {
  name: 'CompanyRecords',
  components: {
    SimpleTable,
    VueDatepickerLocal
  },
  data () {
    return {
      tableHeight: 300,
      timeActive: true,
      fromTime: null,
      toTime: null,
      operationTypes: [{value: '', label: '全部'}],
      detail: '',
      account: '',
      optionValue: '',
      total: 0,
      dataList: [],
      pageSize: 50,
      sortType: 0,
      pageNum: 1,
      currentPage: 1
    }
  },
  props: {
    isactive: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isactive: function (a) {
      if (a) {
        this.defaultOpList()
        this.log()
      }
    },
    optionValue: function () {
      this.log()
    }
  },
  filters: {
    // 时间格式化
    formatDate (value) {
      return formatDate(new Date(value), 'yyyy-MM-dd hh:mm:ss')
    },
    // 格式化操作类型
    formatOptType (operateType = '') {
      let type
      switch (operateType) {
        case 'ADD':
          type = '新建组织关系'
          break
        case 'UNBIND':
          type = '解除组织关系'
          break
        case 'CREATE_ACCOUNT':
          type = '新建账号'
          break
        case 'DELETE_ACCOUNT':
          type = '删除账号'
          break
        case 'EDIT_ACCOUNT':
          type = '编辑账号'
          break
        case 'ASSET_CANCEL':
          type = '取消资产分配'
          break
        case 'ASSET_ALLCATION':
          type = '资产分配'
          break
        case 'ASSET_LENDING':
          type = '资产借出'
          break
        case 'ASSET_ALLCATION_BATCH':
          type = '资产批量分配'
          break
        case 'ASSET_CANCEL_BATCH':
          type = '资产批量收回'
          break
        case 'COMPLETELY_DELETE_ACCOUNT':
          type = '彻底删除'
          break
        case 'BATCH_DELETE_ACCOUNT':
          type = '企业分组列表批量删除'
          break
        case 'BATCH_MOVE_ACCOUNT':
          type = '企业分组列表批量移动分组'
          break
        case 'UNFREEZE_ACCOUNT':
          type = '激活冻结账号'
          break
        default:
          type = ''
      }
      return type
    }
  },
  methods: {
    log () {
      let type
      switch (this.optionValue) {
        case 'ADD':
          type = 1
          break
        case 'UNBIND':
          type = 2
          break
        case 'CREATE_ACCOUNT':
          type = 3
          break
        case 'DELETE_ACCOUNT':
          type = 4
          break
        case 'EDIT_ACCOUNT':
          type = 5
          break
        case 'ASSET_CANCEL':
          type = 6
          break
        case 'ASSET_ALLCATION':
          type = 7
          break
        case 'ASSET_LENDING':
          type = 8
          break
        case 'BATCH_DELETE_ACCOUNT':
          type = 9
          break
        case 'BATCH_MOVE_ACCOUNT':
          type = 10
          break
        case 'UNFREEZE_ACCOUNT':
          type = 11
          break
        default:
          type = 0
      }
      this.sentLog(100107075, {page: 3, type})
    },
    // 时间排序
    timeSort () {
      this.timeActive = !this.timeActive
      if (this.timeActive) {
        this.sortType = 0
      } else {
        this.sortType = 1
      }
      this.queryOpList()
    },
    // 页面跳转
    handleCurrentChange (index) {
      this.pageNum = index
      this.queryOpList()
    },
    handlePageSizeChange (index) {
      this.pageSize = index
      this.pageNum = 1
      this.currentPage = 1
      this.queryOpList()
    },
    // 设置高度
    setTableHeight () {
      this.tableHeight = this.getTableHeight('table-box')
    },
    // 检索
    search () {
      this.sentLog(100107073, {page: 3})
      this.dataList = []
      this.pageNum = 1
      this.currentPage = 1
      this.queryOpList()
    },
    // 初始检索数据
    defaultOpList () {
      this.dataList = []
      this.pageSize = 50
      this.pageNum = 1
      this.currentPage = 1
      this.sortType = 0
      this.detail = ''
      this.account = ''
      this.queryOpList()
    },
    // 请求操作列表
    queryOpList () {
      let params = {
        detail: this.detail ? this.detail.trim() : null,
        userName: this.account ? this.account.trim() : null,
        operateType: this.optionValue ? this.optionValue : null,
        sortType: this.sortType,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      if (this.fromTime) {
        params.startTime = formatDate(new Date(this.fromTime), 'yyyy-MM-dd') + ' 00:00:00'
      }
      if (this.toTime) {
        params.endTime = formatDate(new Date(this.toTime), 'yyyy-MM-dd') + ' 23:59:59'
      }
      this.dataList = []
      ManageService.getRelationLogList(params, projectId).then(res => {
        if (+res.code === 200) {
          const {items = [], totalCount = 0} = res.data || {}
          this.dataList = items
          this.total = totalCount
        } else {
          this.dataList = []
          this.total = 0
        }
      }).catch(e => this.$message.error(e.message))
    },
    // 请求操作类型
    queryOpTypes () {
      let params = {}
      if (this.fromTime) {
        params.fromTime = new Date(
          formatDate(new Date(this.fromTime), 'yyyy-MM-dd')
        ).getTime()
      }
      if (this.toTime) {
        params.toTime =
          new Date(formatDate(new Date(this.toTime), 'yyyy-MM-dd')).getTime() +
          86400000
      }
      ManageService.getRelationLogTypes(params, projectId).then(res => {
        if (+res.code === 200) {
          let options = [{value: '', label: '全部'}]
          const data = res.data || []
          data.forEach(item => {
            options.push({
              value: item.code,
              label: item.name
            })
          })
          this.operationTypes = options
        } else {
        }
      }).catch(e => this.$message.error(e.message))
    }
  },
  mounted () {
    // 设置表格高度
    setTimeout(() => {
      this.setTableHeight()
    })
    this.resizeHandle.resize(() => {
      this.setTableHeight()
    })
    // 获取请求类型
    this.queryOpTypes()
    this.defaultOpList()
    this.log()
  }
}
</script>
